angular.module('impactx.MenuDirectives').controller('GlobalActionsMenuCtrl', ['$context', GlobalActionsMenuCtrl]);

function GlobalActionsMenuCtrl($context)
{
    this.context = $context;
}